<p-dialog
  [header]="definition()?.label ?? 'VIEW_SETTINGS.TITLE' | translate"
  [visible]="!!definition()"
  [modal]="true"
  [draggable]="false"
  (visibleChange)="closeDialog.emit()"
  [dismissableMask]="true"
>
  @if (definition()) {
    <div class="main">
      @for (section of definition()!.sections | keyvalue: originalOrder; track section) {
        <div class="section" [attr.data-qa]="'view-settings-item-' + section.key">
          @if (section.value?.label) {
            <h3>{{ section.value!.label! | translate }}</h3>
          }
          @if (section.value) {
            @for (setting of section.value.settings | keyvalue: originalOrder; track setting) {
              @let id = `settings-item-${section.key}-${setting.key}`;
              <div class="setting" [attr.data-qa]="'view-' + id">
                @if (setting.value && setting.value.type === definitionType.Boolean) {
                  @if (!setting.value.parentId) {
                    <div class="tw:flex tw:items-center tw:gap-3 tw:leading-4">
                      <p-checkbox
                        [(ngModel)]="setting.value.value"
                        [binary]="true"
                        [inputId]="id"
                        [pTooltip]="setting.value.tooltip! | translate"
                        (ngModelChange)="change(section.key, setting.key, $event)"
                      />
                      <label [for]="id">{{ setting.value.label! | translate }}</label>
                    </div>
                  }
                }
                <div class="sub-settings">
                  @for (
                    childSetting of getChildViewSettings(section.value.settings, setting.key) | keyvalue: originalOrder;
                    track childSetting
                  ) {
                    <div class="setting" [attr.data-qa]="'view-' + id">
                      @if (childSetting.value.type === definitionType.Boolean) {
                        <div class="tw:flex tw:items-center tw:gap-3 tw:leading-4">
                          <p-checkbox
                            [(ngModel)]="childSetting.value.value"
                            [binary]="true"
                            [inputId]="'child-' + childSetting.key"
                            [pTooltip]="childSetting.value.tooltip"
                            (ngModelChange)="change(section.key, childSetting.key, $event)"
                          />
                          <label [for]="'child.' + childSetting.key">{{ childSetting.value.label! | translate }}</label>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (setting.value && setting.value.type !== definitionType.Boolean) {
                  <div>
                    @if (setting.value.label) {
                      <label [for]="setting.key">{{ setting.value.label! | translate }}</label>
                    }
                    @if (setting.value.type === definitionType.String) {
                      <input pInputText [(ngModel)]="setting.value.value" [pTooltip]="setting.value.tooltip" />
                    }
                    @if (setting.value.type === definitionType.Number) {
                      <p-inputNumber
                        [(ngModel)]="setting.value.value"
                        [allowEmpty]="true"
                        [pTooltip]="setting.value.tooltip"
                      />
                    }
                    @if (setting.value.type === definitionType.Select) {
                      <p-select
                        [(ngModel)]="setting.value.value"
                        [options]="setting.value.options"
                        [pTooltip]="setting.value.tooltip"
                        appendTo="body"
                      />
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  }
  <p-button data-qa="view-settings-apply" (onClick)="apply.emit()">{{ "VIEW_SETTINGS.APPLY" | translate }}</p-button>
  @if (definition(); as definition) {
    <p-button data-qa="view-settings-reset" (onClick)="resetSettings.emit(definition.localStorageKey)">
      {{ "VIEW_SETTINGS.RESET" | translate }}
    </p-button>
  }
</p-dialog>
